<template>
    <div class="media-resource">
     <header>{{ resInfo.name }}</header>
     <main ref="showRef">

      <video-show v-if="preview.preview_url"  :source="preview.preview_url" />
      <!-- <document-show v-if="documentType.includes(preview.ext)" :preview="preview" />
      <package-show v-if="packageType.includes(preview.ext)" :rid="rid" :res-info="resInfo" />
      <div class="image-show" v-if="imageType.includes(preview.ext) || preview.ext===''">
        <img v-if="imageType.includes(preview.ext)" :src="preview.preview_url" width="100%" height="100%">
        <img v-else :src="require('@/assets/img/file_onverting.jpg')" width="100%" height="100%">
      </div> -->
     </main>
     <footer>
         <div class="operation">
           <div>活动简介:&nbsp;&nbsp;&nbsp;{{resInfo.description.slice(0,1000)||'暂无'}}</div>
           <div>播放量:&nbsp;&nbsp;&nbsp;{{resInfo.viewCount}}</div>
            <!-- <span class="el-icon-view"></span>
            <span>67</span>
            <el-divider direction="vertical"></el-divider> -->
            <!-- <span class="el-icon-download" @click="download"></span>
            <span>下载</span> -->
            <!-- <el-divider direction="vertical"></el-divider>
            <span class="el-icon-star-off"></span>
            <span>889</span> -->
        </div>
     </footer>
    </div>
</template>

<script>
import VideoShow from './video-show.vue'
// import DocumentShow from './document-show.vue'
// import PackageShow from './package-show.vue'
import eventBus from '@/utils/event-bus'
// import services from '@/services'
export default {
  name: 'MediaResource',
  components: {
   VideoShow,
  //  DocumentShow,
  //  PackageShow
  },
  data () {
    return {
      documentType: ['html', 'pdf'],
      packageType: ['zip', 'rar', '7z', 'arj'],
      mediaType: ['mp3', 'mp4'],
      imageType: ['jpeg', 'png', 'jpg', 'gif', 'bmp']
    }
  },
  props: {
    rid: {
      type: String,
      default: ''
    },
    preview: {
      type: Object,
      default: () => ({})
    },
    resInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async download() {
      if(!this.$parent.isLogin()) {
        // todo 去登录页
        this.$message.error('请登录')
        return
      }
      // 下载接口
      try {
        let search = window.location.search
        let cyuId = search.substring(search.indexOf('&cyuid=') + 7,search.length)
        let researchGroup = search.substring(search.indexOf('&researchGroup=') + 15,search.indexOf('&cyuid='))
        const { data, downloadcount } = await this.$api.detail.resDownload({ resId: this.rid, cyuId, researchGroup })
        window.location.href = data
        eventBus.$emit('download-count', downloadcount)
      } catch (error) {
          this.$message.error(error.message)
      }
    }
  },
}
</script>

<style scoped lang="less">
  .media-resource {
    height: 100%;
    display: flex;
    flex-direction: column;
    header {
      height: 35px;
      font-size: 18px;
    }
    main {
      // flex: 1;
      height: 650px;
      .image-show {
        height: 100%;
        position: relative;
        border: 1px solid #F0F0F0;
        img {
          position: absolute;
          object-fit: contain;
        }
      }
    }
    footer {
      height: auto;  
      .operation {
        // float: right;
        font-size: 15px;
        color: #8C8C8C;
        div{
          margin: 10px 0;
        }
        .el-icon-download {
          cursor: pointer;
          &:hover {
            color: #409eff;
          }
        }
      }
    }

  }
</style>
